export default {
	PlaceholderSearch: 'Nhập Tiêu đề, Người gửi để tìm kiếm',
	DateReceived: 'Ngày nhận',
	FromDate: 'Từ ngày',
	ToDate: 'Đến ngày',
	UnProgress: 'Chưa xử lý',
	Progress: 'Đang xử lý',
	ProgressException: 'Xử lý lỗi',
	EmailIllegal: 'Email không hợp lệ',
	InvoiceDuplicated: 'Hóa đơn trùng',
	Progressed: 'Đã xử lý',
	ViewInvoice: 'Xem hóa đơn',
	FileFound: 'Không chứa hóa đơn',
	CheckAgain: 'Kiểm tra lại',
	Delete: 'Xóa',
	Restore: 'Khôi phục',
	FileProcessed: {
		All: 'Tất cả',
		Valid: 'Hợp lệ',
		Invalid: 'Không hợp lệ',
		Duplicate: 'Hóa đơn trùng',
		Draft: 'Hóa đơn nháp',
		NoRead: 'Không đọc được HĐ',
		Expired: 'Hết hạn sử dụng',
		OutOfQuantity: 'Hết số lượng sử dụng',
		FileName: 'Tên tệp',
		Status: 'Trạng thái'
	},
	MailBox: 'Hộp thư đến',
	ImportantBox: 'Thư quan trọng',
	Refresh: 'Làm mới',
	Filter: 'Lọc',
	FilterMail: 'Bộ lọc',
	DeleteMailbox: 'Xóa vĩnh viễn',
	StatusEmail: 'Trạng thái',
	YetSelectEmail: 'Không có thư nào được chọn',
	ReadEmailStatus: 'Trạng thái đọc thư',
	NoHasPdf: 'Chưa có bản thể hiện PDF',
	UnRead: 'Đánh dấu chưa đọc',
	AttachmentFile: 'Tệp đính kèm',
	ListInvoice: 'Danh sách hóa đơn',
	InboxTab: {
		MailBox: 'Hộp thư',
		MailImportaint: 'Thư quan trọng',
		MailSpam: 'Thư rác',
		MailTrash: 'Thùng rác'
	},
	WarningNoteSendXML: 'Vui lòng gửi file XML hóa đơn để đảm bảo việc kiểm tra hóa đơn được thực hiện chính xác nhất',
	InboxSelectedWarning: number => `Bạn chỉ được chọn tối đa ${number} email.`,
	Forward: {
		TitlePage: 'Chuyển tiếp thư',
		UserTake: 'Người nhận',
		MailUserTake: 'Email người nhận',
		LabelText: 'Tiêu đề',
		LabelMail: 'Tiêu đề thư',
		AttachmentFile: 'Tệp đính kèm',
		ResponseInvoiceText: 'phản hồi về hóa đơn điện tử của quý khách',
		TakedEmailTex: 'đã nhận được hóa đơn dưới đây',
		SellerName: '&lt;Thông tin người bán&gt;',
		BuyerNameHtml: '&lt;Thông tin người mua&gt;',
		BuyerName: '<Thông tin người mua>',
		Translate: 'Dịch nội dung'
	},
	InboxV2: {
		NoEmail: 'Bạn chưa có thư',
		NoEmailDescription: 'Gửi hóa đơn đến email nhận hóa đơn của đơn vị',
		TextPromptUserSendMail:
			'Bạn có thể gửi hóa đơn điện tử hoặc chuyển tiếp (forward) email hóa đơn điện tử của bạn',
		ToEmail: 'Đến Email',
		EmainReceive: 'Email nhận hóa đơn: ',
		PromptHaveSomeEmail: 'Bạn có {num} email mới',
		PromptSelectSomeEmail: 'Đã chọn',
		Deselect: 'Bỏ chọn',
		StatusReadMail: {
			Text: 'Trạng thái đọc thư'
		},
		InvoicesStatus: {
			Text: 'Trạng thái',
			SelectAll: 'Chọn tất cả',
			Valid: 'Hóa đơn hợp lệ',
			Invalid: 'HĐ không hợp lệ',
			Match: 'Hóa đơn trùng',
			CannotRead: 'Không đọc được HĐ'
		},
		PromptCanNotReadEmail: `Hiện tại hệ thống chưa nhận diện được hóa
		đơn từ email này. Vui lòng tải lên hóa đơn
		XML để kiểm tra trực tiếp`,
		ConfirmDeleteEmail: "Dữ liệu sau khi xóa vẫn có thể được khôi phục lại tại mục 'Thùng rác'.",
		ConfirmDeleteAllEmailChoose: "Dữ liệu sau khi xóa vẫn có thể được khôi phục lại tại mục 'Thùng rác'.",
		ConfirmDeleteEmailTitle: 'Bạn muốn xóa thư',
		InvoiceMatch: 'Hóa đơn trùng',
		EmailTakeInvoice: 'Email nhận hóa đơn',
		EmailSizeExceeded: 'Dung lượng email vượt quá 10MB',
		StorageInfo: {
			EmailStorage: {
				part1: 'Lưu trữ thư: Tối đa',
				part2: '6 tháng',
				part3: '; Lưu trữ hóa đơn: Tối đa',
				part4: '10 năm'
			},
			MaxEmailSize: {
				part1: 'Dung lượng email tối đa:',
				part2: '10MB'
			},
			SupportedAttachments: {
				part1: 'Hỗ trợ tệp đính kèm:',
				part2: 'PDF, XML, INV, hình ảnh'
			},
			DeleteNote: 'Thao tác xóa thư không ảnh hưởng đến các hóa đơn đã lưu trữ trên chương trình'
		},
		Max10MbWarning: sizeMB =>
			`Không thể xử lý do dung lượng email của bạn là <span style="color: #f5222d; font-weight: bold">${sizeMB}</span> MB. Phần mềm chỉ tiếp nhận email có tổng dung lượng dưới <span style="color: #f5222d; font-weight: bold">10MB.</span> Vui lòng tách thành <strong>nhiều email</strong> và gửi lại.`
	},
	SpamBox: {
		DontHaveEmail: 'Không có thư rác'
	},
	TrashBox: {
		DontHaveEmail: 'Thùng rác trống'
	},
	DeleteEmailSuccess: 'Đã xóa thư thành công',
	ReportSpamSuccess: 'Báo cáo spam thành công',
	ReportNotSpamSuccess: 'Đánh dấu không phải spam thành công',
	ConfirmDeleteForeverEmail: 'Dữ liệu sau khi xóa sẽ không thể khôi phục lại.',
	ConfirmDeleteForeverAllChooseEmail: 'Dữ liệu sau khi xóa sẽ không thể khôi phục lại.',
	DeleteSpamEmailTite: 'Bạn muốn xóa thư rác',
	//Bổ sung:
	Draf: 'Bản nháp',
	CheckingInvoice: 'Đang kiểm tra HĐ',
	AlertSaveMail: 'Tất cả thư sẽ được lưu trữ trong vòng 6 tháng kể từ ngày nhận thư',
	WarningTextEmailSpoofed:
		'Email này có thể là giả mạo. Vui lòng đọc kỹ trước khi thực hiện để tránh nguy cơ lừa đảo!',
	WarningContentEmail: 'Nội dung email không được để trống.',
	SenderInformation: 'Thông tin người gửi',
	From: 'Người gửi'
};
